var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import OkCancelModal from '@/shared/components/OkCancelModal';
import { createRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { messages } from './accessTokenMessages';
import { useGetClients } from '@/shared/hooks/accessTokens/useGetClients';
import { useGetScopes } from '@/shared/hooks/accessTokens/useGetScopes';
import DatePicker from '@/shared/components/input/DatePicker';
import classNames from 'classnames';
import { isBefore, isBeforeMinimum, isBeforeTomorrow, } from '@/shared/utils/validationHelpers';
import moment from 'moment';
import { groupBy } from '@/shared/utils/groupBy';
import { Scope } from './scope/Scope';
import { useModalContext } from '@/shared/providers/ModalProvider';
import { useCreateAcccessToken } from '@/shared/hooks/accessTokens/useCreateAccessToken';
import { useQueryClient } from '@tanstack/react-query';
import { AccessTokenQueryKey } from '@/shared/hooks/accessTokens/queryKey';
import './CreateAccessToken.scss';
var DefaultTokenRequest = {
    scopes: [],
    expires: moment().add(1, 'year'),
    name: '',
    clientId: '',
};
var CreateAccessToken = function (_a) {
    var _b = _a.show, show = _b === void 0 ? false : _b;
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var intl = useIntl();
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var clients = useGetClients();
    var scopes = useGetScopes();
    var _d = useState(null), createdToken = _d[0], setCreatedToken = _d[1];
    var createAccessToken = useCreateAcccessToken().createAccessToken;
    var queryClient = useQueryClient();
    var form = createRef();
    var _e = useState(false), expiredFocused = _e[0], setExpiredFocused = _e[1];
    var _f = useState(__assign({}, DefaultTokenRequest)), tokenRequest = _f[0], setTokenRequest = _f[1];
    var _g = useState(false), showValidation = _g[0], setShowValidation = _g[1];
    var valueChanged = function (key, value) {
        var _a;
        setTokenRequest(__assign(__assign({}, tokenRequest), (_a = {}, _a[key] = value, _a)));
    };
    var createToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var scopes_1, expires, clientId, name_1, newToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!createdToken) return [3 /*break*/, 3];
                    scopes_1 = tokenRequest.scopes, expires = tokenRequest.expires, clientId = tokenRequest.clientId, name_1 = tokenRequest.name;
                    if (scopes_1.length === 0 || !expires || !clientId || !name_1) {
                        setShowValidation(true);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    return [4 /*yield*/, createAccessToken(__assign(__assign({}, tokenRequest), { expires: tokenRequest.expires.toISOString() }))];
                case 1:
                    newToken = _a.sent();
                    setCreatedToken(newToken);
                    return [4 /*yield*/, queryClient.invalidateQueries([AccessTokenQueryKey.AccessTokens])];
                case 2:
                    _a.sent();
                    setLoading(false);
                    return [2 /*return*/];
                case 3:
                    setShowModalInfo({});
                    return [2 /*return*/];
            }
        });
    }); };
    var closeModal = function () {
        setShowModalInfo({});
    };
    var onScopeToggle = function (name) {
        var currentIndex = tokenRequest.scopes.indexOf(name);
        if (currentIndex > -1) {
            setTokenRequest(__assign(__assign({}, tokenRequest), { scopes: tokenRequest.scopes.filter(function (x) { return x !== name; }) }));
        }
        else {
            setTokenRequest(__assign(__assign({}, tokenRequest), { scopes: __spreadArray(__spreadArray([], tokenRequest.scopes, true), [name], false) }));
        }
    };
    var selectAllScopes = function () {
        setTokenRequest(__assign(__assign({}, tokenRequest), { scopes: __spreadArray([], scopes.data.map(function (x) { return x.name; }), true) }));
    };
    var unselectAllScopes = function () {
        setTokenRequest(__assign(__assign({}, tokenRequest), { scopes: [] }));
    };
    var renderScopes = function () {
        var data = scopes.data;
        var dataWithPrefix = data.map(function (scope) { return (__assign(__assign({}, scope), { prefix: scope.name.split('.')[0] })); });
        var grouped = groupBy(dataWithPrefix, function (x) { return x.prefix; });
        var keys = Object.keys(grouped);
        return keys.map(function (x) { return (_jsx(Scope, { title: x, scopes: grouped[x], disabled: !!createdToken, selectedScopes: tokenRequest.scopes, onScopeToggled: onScopeToggle }, x)); });
    };
    var copy = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, navigator.clipboard.writeText(createdToken)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var renderClients = function () {
        var renderName = function (name) {
            return name === 'MyOffice' ? intl.formatMessage(messages.MyOffice) : name;
        };
        return clients.data.map(function (x) { return (_jsxs("option", __assign({ value: x.id }, { children: [renderName(x.name), " ", x.description && "| ".concat(x.description)] }), x.id)); });
    };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.CreateAccessToken), show: show, onClose: closeModal, disabled: loading, onSave: createToken, zendeskArticle: '8331100368924' }, { children: show && !clients.isLoading && !scopes.isLoading && (_jsxs("form", __assign({ ref: form }, { children: [createdToken && (_jsx("div", __assign({ className: "form-group" }, { children: _jsxs("div", __assign({ className: "alert alert-success", role: "alert" }, { children: [intl.formatMessage(messages.TokenCreated), " ", _jsx("strong", { children: createdToken }), ' ', _jsx("i", { style: { cursor: 'pointer' }, onClick: copy, className: "fa fa-copy" }), " ."] })) }))), _jsxs("div", __assign({ className: "form-horizontal" }, { children: [_jsxs("div", __assign({ className: classNames('form-group', {
                                'has-error': showValidation && !tokenRequest.name.trim(),
                            }) }, { children: [_jsx("label", __assign({ className: "col-sm-2 create-access-token-label" }, { children: intl.formatMessage(messages.Name) })), _jsx("div", __assign({ className: "col-sm-10" }, { children: _jsx("input", { disabled: !!createdToken, type: "text", autoFocus: true, value: tokenRequest.name, placeholder: intl.formatMessage(messages.Name), onChange: function (e) { return valueChanged('name', e.target.value); }, required: true, className: "form-control" }) }))] })), _jsxs("div", __assign({ className: classNames('form-group', {
                                'has-error': isBeforeMinimum(tokenRequest.expires) ||
                                    !isBefore(tokenRequest.expires, moment().add(5, 'year')),
                            }) }, { children: [_jsx("label", __assign({ className: "col-sm-2 create-access-token-label" }, { children: intl.formatMessage(messages.Expires) })), _jsx("div", __assign({ className: "col-sm-10" }, { children: _jsx(DatePicker, { placeholder: intl.formatMessage(messages.Expires), date: tokenRequest.expires, onDateChange: function (e) { return valueChanged('expires', e); }, focused: expiredFocused, onFocusChange: function (_a) {
                                            var focused = _a.focused;
                                            return setExpiredFocused(focused);
                                        }, block: true, small: true, isOutsideRange: function (date) {
                                            return isBeforeTomorrow(date) || !isBefore(date, moment().add(5, 'year'));
                                        }, phrases: {}, numberOfMonths: 1, disabled: !!createdToken }) }))] })), _jsxs("div", __assign({ className: classNames('form-group', {
                                'has-error': showValidation && !tokenRequest.clientId,
                            }) }, { children: [_jsx("label", __assign({ className: "col-sm-2 create-access-token-label" }, { children: intl.formatMessage(messages.Client) })), _jsx("div", __assign({ className: "col-sm-10" }, { children: _jsxs("select", __assign({ className: "form-control", disabled: !!createdToken, onChange: function (e) { return valueChanged('clientId', e.target.value); } }, { children: [_jsx("option", {}), renderClients()] })) }))] })), _jsxs("div", __assign({ className: classNames('form-group', {
                                'has-error': showValidation && tokenRequest.scopes.length === 0,
                            }) }, { children: [_jsxs("div", __assign({ className: "col-sm-12" }, { children: [renderScopes(), showValidation && tokenRequest.scopes.length === 0 && (_jsx("div", __assign({ className: "text-danger" }, { children: intl.formatMessage(messages.ScopesRequired) })))] })), _jsxs("div", __assign({ className: "col-sm-12" }, { children: [_jsx("button", __assign({ type: "button", disabled: !!createdToken, onClick: unselectAllScopes, className: "btn btn-default" }, { children: intl.formatMessage(messages.UnselectAll) })), _jsx("button", __assign({ type: "button", disabled: !!createdToken, onClick: selectAllScopes, className: "btn btn-secondary margin10L" }, { children: intl.formatMessage(messages.SelectAll) }))] }))] }))] }))] }))) })));
};
export default CreateAccessToken;
